import { StrictMode } from 'react'
import { createRoot } from 'react-dom/client'
import App from './App.tsx'
import AppErrorBoundary from './components/common/AppErrorBoundary'
import { getPerformanceMonitor } from './utils/performance'
import './index.css'

// Initialize performance monitoring
const performanceMonitor = getPerformanceMonitor();

// Initialize Web Vitals tracking
performanceMonitor.onWebVitals((metric) => {
  // Log to console in development
  if (import.meta.env.DEV) {
    console.log(`Web Vital [${metric.name}]:`, {
      value: metric.value,
      rating: metric.rating,
      delta: metric.delta,
    });
  }

  // In production, you would send to monitoring service
  // Example: sendToMonitoringService(metric);
});

// Track app initialization time
const appStartTime = performance.now();

createRoot(document.getElementById("root")!).render(
  <StrictMode>
    <AppErrorBoundary>
      <App />
    </AppErrorBoundary>
  </StrictMode>
);

// Track app initialization completion
const appInitTime = performance.now() - appStartTime;
performanceMonitor.recordMetric('app-initialization', {
  name: 'app-initialization',
  value: appInitTime,
  timestamp: Date.now(),
  metadata: { phase: 'render-complete' },
});


